import React from 'react';
import PlaceHolderImg2x from '../../assets/images/placeholder@2x.png';
import { parseDate } from '../../lib/function';
import * as CONST from '../../constants/Const';

export default class TaskCardForDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      image: this.props.task.taskPhotoId || null
    };
  }

  _renderDate = () => {
    var date = '';
    var obj = parseDate(this.props.task.startDate);
    date = obj.year + '年' + obj.month + '月' + obj.day + '日';
    var obj = parseDate(this.props.task.endDate);
    date += ' - ' + obj.year + '年' + obj.month + '月' + obj.day + '日';
    return `${date} ${this.props.task.startTime}-${this.props.task.endTime}`;
  };

  _renderImage = () => {
    console.log('TCL: TaskCardForDetail -> _renderImage -> this.props', this.props.noImage);
    if (this.props.noImage !== undefined && this.props.noImage === true) {
      return null;
    } else if (!this.props.task.taskPhotoId) {
      return (
        <div className="col-sm-4 taskImage">
          <div
            className="task-icon task-icon-in-detail"
            style={{ backgroundImage: `url(${PlaceHolderImg2x})` }}
          ></div>
        </div>
      );
    } else {
      return (
        <div className="col-sm-4 taskImage">
          <div
            className="task-icon task-icon-in-detail"
            style={{ backgroundImage: `url(${this.props.task.taskPhotoId})` }}
          ></div>
        </div>
      );
    }
  };

  render = () => {
    let categories = null;
    let categoryDetail = this.props.task.taskCategoryDetail || [];
    console.log('TCL: TaskCardForDetail -> render -> this.props.task', this.props.task);

    if (categoryDetail.constructor === Array) {
      categories = categoryDetail.map(cat => {
        return <span key={cat.key}>{cat.value}</span>;
      });
    } else if (categoryDetail.constructor === Object) {
      categories = <span>{categoryDetail.value}</span>;
    }

    let task =
      !!this.props.Task && !!this.props.Task.taskDetail
        ? this.props.Task.taskDetail
        : { approvalTask: null, activeTask: null, cancelTask: null, offerTask: null };
    let approvedUsers = [],
      activeUsers = [],
      cancelUsers = [],
      offerUsers = [];
    if (this.state.loaded) {
      if (Object.keys(task).length > 0) {
        approvedUsers = task.approvalTask === null ? [] : task.approvalTask;
        activeUsers = task.activeTask === null ? [] : task.activeTask;
        cancelUsers = task.cancelTask === null ? [] : task.cancelTask;
        offerUsers = task.offerTask === null ? [] : task.offerTask;
      }
    }
    const allEntryCount = this.props.allEntryCount || approvedUsers.length;

    const colorCode =
      this.props.task.taskStatusId === CONST.TS_CREATE
        ? '#0db100'
        : this.props.task.taskStatusId === CONST.TS_APPROVED
          ? '#b95b68'
          : '';
    const taskEndDateTime = new Date(`${this.props.task.endDate} ${this.props.task.endTime}`);
    var canDoReview =
      this.props.task.taskStatusDetail &&
      this.props.task.taskStatusDetail.key === CONST.TS_APPROVED &&
      taskEndDateTime < new Date();
    var noApproved =
      this.props.task.taskStatusDetail &&
      this.props.task.taskStatusDetail.key === CONST.TS_CREATE &&
      this.props.allEntryCount >= 0 &&
      taskEndDateTime < new Date();
    console.log('TCL: TaskCardForDetail -> render -> noApproved', noApproved, task);
    return (
      <div className="task-delete-inner">
        <div className="row">
          {this._renderImage()}
          <div className="col-sm-8">
            <div className="task-detail-content">
              <span style={{ color: colorCode }}>
                {canDoReview
                  ? 'レビュー待ち'
                  : noApproved
                    ? '募集終了'
                    : this.props.task.taskStatusDetail &&
                    this.props.task.taskStatusDetail.displayStatus}
              </span>
              <h2>{this.props.task.title}</h2>
              <ul>
                <li>
                  <h3>タスクID :</h3>
                  <h4>{this.props.task.taskId}</h4>
                </li>
                <li>
                  <h3>日時 :</h3>
                  <h4>{this._renderDate()}</h4>
                </li>
                <li>
                  <h3>募集人数 :</h3>
                  <h4>{'1'}人</h4>
                </li>
                <li>
                  <h3>応募人数 :</h3>
                  <h4>{allEntryCount}人</h4>
                </li>
                <li>
                  <h3>仕事カテゴリ :</h3>
                  <h4>{categories}</h4>
                </li>
                <li>
                  <h3>給与 :</h3>
                  <h4>
                    {String(this.props.task.fee).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}円
                  </h4>
                </li>
                <li>
                  <h3>必須資格 :</h3>
                  <h4>
                    {(() => {
                      if (
                        this.props.task &&
                        this.props.task.licenseDetail &&
                        this.props.task.licenseDetail.length > 0
                      ) {
                        return this.props.task.licenseDetail.map((license, i) => {
                          const last = i + 1 === this.props.task.licenseDetail.length;
                          let text;
                          if (last) {
                            text = license.value;
                          } else {
                            text = `${license.value}/`;
                          }
                          return <span key={i}>{text}</span>;
                        });
                      } else {
                        return <span>資格なし</span>;
                      }
                    })()}
                  </h4>
                </li>
                <li>
                  <h3>タスク実施住所 :</h3>
                  <h4>
                    {this.props.task.task_postalCode +
                      ' ' +
                      this.props.task.task_prefecture +
                      ' ' +
                      this.props.task.task_city +
                      ' ' +
                      this.props.task.task_block +
                      ' ' +
                      this.props.task.task_street}
                  </h4>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="task-description">
          <p>{this.props.task.description}</p>
        </div>
      </div>
    );
  };
}
